import React from "react";
import { Link } from "react-router-dom";

const ApiAccessEmptyState = () => (
  <div className="text-center py-16">
    <div className="w-20 h-20 mx-auto mb-6 rounded-full bg-theme-secondary flex items-center justify-center">
      <svg
        className="w-10 h-10 text-theme-text opacity-30"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M17.25 6.75L22.5 12l-5.25 5.25m-10.5 0L1.5 12l5.25-5.25m7.5-3l-4.5 16.5"
        />
      </svg>
    </div>
    <h3 className="text-xl font-semibold text-theme-text mb-2">API & MCP</h3>
    <p className="text-theme-text opacity-60 max-w-md mx-auto mb-6">
      Connect agents to Weave with a public REST API and MCP server. Available on Launch and above.
    </p>
    <Link
      to="/account/billing/"
      className="inline-flex px-4 py-2 rounded-md bg-theme-primary text-theme-button hover:opacity-90"
      style={{ backgroundColor: "var(--theme-primary)", color: "var(--theme-button-text)" }}
    >
      Upgrade plan
    </Link>
  </div>
);

export default ApiAccessEmptyState;
